module.exports = __webpack_public_path__ + "img/logo_login.e88881d7.png";